var $class="se2--header-se--country-selector",$name="HeaderSE/countrySelector",$path="app/components/HeaderSE/deferrals/countrySelector/config.js",$this={$class,$name,$path,};// eslint-disable-next-line import/prefer-default-export
export const countrySelectorSEClassName = $class;
export const countrySelectorSESectionSelector = `.${$class} .section`;
